import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Crimson_Pro\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-crimson-pro\",\"display\":\"swap\"}],\"variableName\":\"crimsonPro\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\",\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"JetBrains_Mono\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-jetbrains-mono\",\"display\":\"swap\",\"preload\":false}],\"variableName\":\"jetbrainsMono\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/katex/dist/katex.min.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/app/src/components/i18n/I18nProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionGuard"] */ "/app/src/components/session-guard/SessionGuard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InstallBanner"] */ "/app/src/features/pwa/InstallBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerRegistrar"] */ "/app/src/features/pwa/ServiceWorkerRegistrar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UpdateBanner"] */ "/app/src/features/pwa/UpdateBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useInstallPrompt"] */ "/app/src/features/pwa/useInstallPrompt.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useVersionCheck"] */ "/app/src/features/pwa/useVersionCheck.ts");
;
import(/* webpackMode: "eager", webpackExports: ["StageChip","useStageLabel"] */ "/app/src/features/stage-marker/StageChip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StageMarker"] */ "/app/src/features/stage-marker/StageMarker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useStageCue"] */ "/app/src/features/stage-marker/useStageCue.ts");
